<ng-content></ng-content>

<form [formGroup]="form">
  <div class="flex items-center">
    <p-checkbox
      inputId="notFoundProvider"
      data-test-id="provider-not-found-checkbox"
      inputId="providerNotFound"
      formControlName="acknowledged"
      [binary]="true"
    ></p-checkbox>
    <label for="providerNotFound" class="ml-2">{{ acknowledgementText }}</label>
  </div>
  @if (form.get('acknowledged').value) {
    <p-panel class="block mt-6" [header]="panelHeader">
      <div class="grid grid-cols-12 gap-4 p-fluid p-form-widget p-form-aligned">
        <div class="col-span-12 lg:col-span-6">
          <div class="field">
            <label class="field-required">First Name:</label>
            <div class="p-field-value">
              <input pInputText trimInputValue type="text" formControlName="firstName" data-test-id="first-name-input" />
              <errors-messages [control]="form.get('firstName')"></errors-messages>
            </div>
          </div>
          <div class="field">
            <label class="field-required">Last Name:</label>
            <div class="p-field-value">
              <input pInputText trimInputValue type="text" formControlName="lastName" data-test-id="last-name-input" />
              <errors-messages [control]="form.get('lastName')"></errors-messages>
            </div>
          </div>
          <div class="field">
            <label class="field-required">NPI:</label>
            <div class="p-field-value">
              <p-inputMask
                data-test-id="npi-number-input"
                formControlName="practiceNpinumber"
                mask="9999999999"
                slotChar=""
                [autoClear]="false"
              />
              <errors-messages [control]="form.get('practiceNpinumber')"></errors-messages>
            </div>
          </div>
          <div class="field">
            <label class="field-required">Tax ID:</label>
            <div class="p-field-value">
              <p-inputMask
                data-test-id="practice-tax-id-input"
                formControlName="practiceTaxId"
                mask="999999999"
                slotChar=""
                [autoClear]="false"
              />
              <errors-messages [control]="form.get('practiceTaxId')"></errors-messages>
            </div>
          </div>
        </div>
        <div class="col-span-12 lg:col-span-6">
          <div class="field">
            <label>Street:</label>
            <div class="p-field-value">
              <input pInputText trimInputValue type="text" formControlName="physicalStreet" data-test-id="street-input" />
              <errors-messages [control]="form.get('physicalStreet')"></errors-messages>
            </div>
          </div>
          <div class="field">
            <label>City:</label>
            <div class="p-field-value">
              <input pInputText trimInputValue type="text" formControlName="physicalCity" data-test-id="city-input" />
              <errors-messages [control]="form.get('physicalCity')"></errors-messages>
            </div>
          </div>
          <div class="field">
            <label>State:</label>
            <div class="p-field-value">
              <p-select placeholder="Select" formControlName="physicalState" [options]="states" data-test-id="state-dropdown">
              </p-select>
            </div>
          </div>
          <div class="field">
            <label>ZIP Code:</label>
            <div class="p-field-value">
              <p-input-mask
                type="text"
                mask="99999?-9999"
                formControlName="physicalZip"
                [unmask]="true"
                [autoClear]="false"
                data-test-id="zip-code-input"
                >
              </p-input-mask>
              <errors-messages [control]="form.get('physicalZip')"></errors-messages>
            </div>
          </div>
          <div class="field">
            <label>Phone:</label>
            <div class="p-field-value">
              <p-input-mask
                type="text"
                mask="(999) 999-9999"
                formControlName="phone"
                [unmask]="true"
                [autoClear]="false"
                data-test-id="phone-number-input"
                >
              </p-input-mask>
              <errors-messages [control]="form.get('phone')"></errors-messages>
            </div>
          </div>
          <div class="field">
            <label>Fax:</label>
            <div class="p-field-value">
              <p-input-mask
                type="text"
                mask="(999) 999-9999"
                formControlName="fax"
                [unmask]="true"
                [autoClear]="false"
                data-test-id="fax-number-input"
                >
              </p-input-mask>
              <errors-messages [control]="form.get('fax')"></errors-messages>
            </div>
          </div>
        </div>
      </div>
    </p-panel>
  }
</form>
